import { render, staticRenderFns } from "./MyRecipesModal.vue?vue&type=template&id=1f7d3a19&"
import script from "./MyRecipesModal.vue?vue&type=script&lang=js&"
export * from "./MyRecipesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports